<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { ref } from "vue";
import StoreLocatorModal from "@/components/location/StoreLocatorModal.vue";

const showStoreLocator = ref(false);
const store = useStore();

const cartCount = computed(() => store.getters["cart/totalItems"]);
</script>

<template>
  <header class="site-header">
    <div class="pc-container site-header__inner">
      <label class="site-header__search">
        <ion-icon name="search-outline" aria-hidden="true"></ion-icon>

        <input
          type="search"
          placeholder="Buscar productos chidos..."
          aria-label="Buscar productos"
        />
      </label>

      <router-link to="/" class="site-header__logo">
        <img
          src="/img/logo.png"
          alt="Productos Chidos"
          class="site-header__logo-img"
        />
      </router-link>

      <div class="site-header__right">
        <button
          class="site-header__location"
          type="button"
          aria-label="Ubica tu tienda"
          @click="showStoreLocator = true"
        >
          <ion-icon name="location-outline" aria-hidden="true"></ion-icon>

          <span> Ubica tu tienda </span>
        </button>

        <router-link
          to="/carrito"
          class="site-header__cart"
          aria-label="Carrito de compras"
        >
          <ion-icon name="bag-outline" aria-hidden="true"></ion-icon>

          <span class="site-header__cart-count">
            {{ cartCount }}
          </span>
        </router-link>
      </div>
    </div>
  </header>
  <StoreLocatorModal
    v-model="showStoreLocator"
    @confirmed="selectedStore = $event"
  />
</template>
